import { API_URLs } from "../../../../utilities/API_URLs"
import iAxios from "../../../../utilities/axios/axios-setup"
import { Http } from "../../../../utilities/axios/http"
import { CementPackagingPageState, NewCementPackagingRequest } from "./_model"
// import { NewRoleData, UserRolePageState } from "./_model"

/* export const postNewCementPackaging = (data: NewCementPackagingRequest) => {
  return iAxios.post(API_URLs.settings.cementPackaging.postCementPackaging, data)
  .then(r => {
    return r.data
  })
  .catch(e => {
    return null
  })
}

export const getCementPackagingList = (pageState: CementPackagingPageState) => {
  const obj: any = {...pageState}
  Object.keys(pageState).forEach((key: any) => {
    if (key === 'order') {
      console.log('The order key ')
      obj['order[' + (pageState?.order?.dataKey ?? '') + ']'] = pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString()
    }
    
  })
  delete obj['order']
  return iAxios.get(API_URLs.settings.cementPackaging.getCementPackagingList + '?' + new URLSearchParams(obj) )
  .then(r => {
    return r?.data
  })
  .catch(e => {
    return null
  })
}

export const getCementPackagingById = (id: string) => {
  return iAxios.get(API_URLs.settings.cementPackaging.getCementPackagingById?.replace('{id}', id))
  .then(r => r.data)
  .catch(e => null)
}

export const patchCementPackagingById = (id: string, data: NewCementPackagingRequest) => {
  return iAxios.patch(API_URLs.settings.cementPackaging.patchCementPackagingById?.replace('{id}', id), {...data, id}, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    }
  })
  .then(r => {
    return r.data
  })
  .catch(e => {
    return null
  })
}

export const deleteCementPackagingById = (id: string) => {
  return iAxios.delete(API_URLs.settings.cementPackaging.deleteCementPackagingById?.replace('{id}', id))
  .then(r => ({success: true, data: r.data}))
  .catch(e => null)
} */

export class CementPackagingService {
  static getCementPackagingList = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.settings.cementPackaging,
        params
      );
    } catch(error) {
      return error;
    }
  }

  static getCementPackaging = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.settings.cementPackaging}/${id}`);
    } catch (error) {
      return error;      
    }
  }

  static createCementPackaging = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.cementPackaging, data);
    } catch (error) {
      return error;
    }
  }

  static updateCementPackaging = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.cementPackaging, data);
    } catch (error) {
      return error;
    }
  }

  static deleteCementPackaging = async (id: number) => {
    try {
      return await Http.delete(`${API_URLs.settings.cementPackaging}/${id}`);
    } catch (error) {
      return error;
    }
  }
}